<template>
  <div class="sticky-holder" style="position: relative; height: auto;">
    <div class="control-group space-between sticky" style="left: 0px; top: 0px; z-index: 100; position: static;">
      <div style="width:100%">
        <ul class="nav nav-step">
          <!--<li class="checked">-->
          <li class="on">
            <i>1</i>IDC  선택</li>
          <li>
            <i>2</i>약관동의</li>
          <li>
            <i>3</i>출입정보입력</li>
          <li>
            <i>3</i>출입정보확인</li>
        </ul>
      </div>             
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>